module.exports = __webpack_public_path__ + "img/Flag_of_Germany.6e41aa3c.svg";